<p-multiSelect *ngIf="!eUnico()" appendTo="body" [options]="instancias" [filter]="true" [style]="{'width':'200px'}" optionValue="id"
    optionLabel="nome" [(ngModel)]="selecionadas" dataKey="id" inputId="id" placeholder="Instância"
    emptyMessage="Nenhuma instância" (ngModelChange)="selecionadasChange.emit($event)" (onChange)="change($event)" (onPanelHide)="fnOnPanelHide($event)">

</p-multiSelect>


<p-dropdown *ngIf="eUnico()"
        appendTo="body"
        [options]="instancias"
        [filter]="true"
        [style]="{ width: '200px' }"
        optionValue="id"
        optionLabel="nome"
        [(ngModel)]="selecionadas"
        (ngModelChange)="selecionadasChange.emit($event)"
        dataKey="id"
        inputId="id"
        placeholder="Instância"
        emptyMessage="Nenhuma instância"
        (onChange)="change($event)"
        id="instancia"
      >
      </p-dropdown>